<template>
  <div class="public-interactions-event-view-body" v-if="items.length">
    <img
      v-if="image"
      :src="mixinGetFilePath(image, 'O')"
      alt=""
      class="public-interactions-display-image"
    />

    <div class="public-interactions-content-classic">
      <div v-if="title" class="public-interactions-title ql-editor">
        {{ title }}
      </div>
      <div
        v-if="description"
        v-html="description"
        class="public-interactions-description ql-editor"
      ></div>
      <div class="public-interactions-expand-button">
        <span
          v-if="totalMatchedEvent"
          @click="updateFullTab"
          class="public-interactions-expand-button-content"
        >
          <md-icon class="public-interactions-icon">remove_red_eye</md-icon>
          <span class="public-interactions-count">{{ totalMatchedEvent }}</span>
          <span class="public-interactions-expand-button-text">
            Event record(s) available to view
          </span>
        </span>
        <span
          class="public-interactions-expand-button-content"
          @click="updateFullTab"
          v-else
        >
          {{ isCompactCollapsed ? 'Tap to close' : 'Tap to explore' }}
        </span>
      </div>
    </div>

    <div ref="mainTab" tabindex="-1">
      <div
        v-if="isCompactCollapsed"
        class="public-interactions-classic-items-container"
      >
        <div v-for="(interaction, index) in items" :key="index">
          <interactions-item
            @on-open-attachments="openAttachmentsGallery"
            :item="interaction"
            :task-img-promise="getTaskImage"
          ></interactions-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InteractionsItem from '../generic/interactionsItem';
import { GraphqlFastQuery } from '@/api/graphql';
import { query as getTask } from '@/graphql/task';

export default {
  components: {
    InteractionsItem,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    valueChain: {
      type: Object,
      required: false,
    },
    image: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      attachments: false,
      visible: false,
      taskImgPromises: {},
      isCompactCollapsed: false,
    };
  },
  methods: {
    openAttachmentsGallery(attachments) {
      this.attachments = attachments;
      this.visible = true;
    },
    getTaskImage(taskId) {
      let promise = GraphqlFastQuery(getTask, {
        fetchPolicy: 'cache-first',
        variables: {
          taskId: String(taskId),
        },
      })
        .then((response) => {
          return response.data.publicTask.icon
            ? response.data.publicTask.icon
            : response.data.publicTask.publicTaskLibrary.icon;
        })
        .catch(() => null);

      return promise;
    },
    updateFullTab() {
      this.isCompactCollapsed = !this.isCompactCollapsed;
      this.$nextTick(function () {
        if (this.isCompactCollapsed) {
          window.scrollBy({
            top: 400,
            behavior: 'smooth',
          });
        } else {
          window.scrollBy({
            top: -400,
            behavior: 'smooth',
          });
          this.$refs.mainTab.focus();
        }
      });
    },
  },
  computed: {
    elementItems() {
      let elements = [];
      if (
        this.valueChain &&
        this.valueChain.elements &&
        this.valueChain.elements.length
      ) {
        elements = this.valueChain.elements
          .filter((item) => !!item.enabled)
          .map((elm) => {
            const interactions = this.items.filter(
              (interaction) =>
                interaction.valueChainElement &&
                interaction.valueChainElement.id === elm.id,
            );
            elm.interactions = interactions;
            return elm;
          });
      }

      return elements;
    },
    totalMatchedEvent() {
      return this.items.length;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-interactions.scss';
</style>
